export default (examName: string) => {
  if (examName === 'GMAT') {
    return [
      { name: 'Overall', scoreRange: { low: 205, high: 805 } },
      { name: 'Quant', scoreRange: { low: 60, high: 90 } },
      { name: 'Verbal', scoreRange: { low: 60, high: 90 } },
      { name: 'Data', scoreRange: { low: 60, high: 90 } }
    ];
  } else if (examName === 'GRE') {
    return [
      { name: 'Overall', scoreRange: { low: 260, high: 340 } },
      { name: 'Math', scoreRange: { low: 130, high: 170 } },
      { name: 'Verbal', scoreRange: { low: 130, high: 170 } }
    ];
  } else if (examName === 'SAT') {
    return [
      { name: 'Overall', scoreRange: { low: 400, high: 1600 } },
      { name: 'Reading & Writing', scoreRange: { low: 200, high: 800 } },
      { name: 'Math', scoreRange: { low: 200, high: 800 } }
    ];
  } else if (examName === 'TOEFL') {
    return [
      { name: 'Overall', scoreRange: { low: 1, high: 6 } },
      { name: 'Reading', scoreRange: { low: 1, high: 6 } },
      { name: 'Listening', scoreRange: { low: 1, high: 6 } },
      { name: 'Writing', scoreRange: { low: 1, high: 6 } },
      { name: 'Speaking', scoreRange: { low: 1, high: 6 } }
    ];
  } else {
    return [
      { name: 'Overall', scoreRange: { low: 0, high: 0 } }
    ];
  }
}
